export default "__VITE_ASSET__yEO3HwY$__"